import React, { useCallback } from 'react'
import classNames from 'classnames'
import Path from '@leverege/path'
import { Button, Flex, Dialog, Dialogs } from '@leverege/ui-elements'
import SimAttributeView from './SimAttributeView'

import S from './style.css'

const EMPTY = []
const CLEAR = {}

export default function ArrayAttributeView( props ) {
  const { onSetValue, node : attr, device, deviceData, controller, cxt = {} } = props
  const path = attr.path.substring( 0, attr.path.length - 1 )

  let v = Path.get( path, deviceData )
  if ( !Array.isArray( v ) ) {
    v = EMPTY
  }

  const onChange = useCallback( ( e ) => {
    const nv = [ ...v ]
    nv[e.data] = e.value
    onSetValue( { attribute : attr, cxt, path, value : nv } )
  }, [ v, attr, cxt, path, onSetValue ] )

  const onDelete = useCallback( ( e ) => {
    if ( e.data === CLEAR ) {
      const onClose = Dialogs.show( {
        component : Dialog.Question,
        props : {
          title : 'Delete All Indices',
          okay : 'Delete All',
          message : `Are you sure you want to delete ALL indices at "${path}"?`,
          onOkay : ( e ) => {    
            onSetValue( { attribute : attr, cxt, path, value : null } )
            onClose()
          }, 
          onCancel : () => { onClose() }
        }
      } )
    } else {

      const onClose = Dialogs.show( {
        component : Dialog.Question,
        props : {
          title : 'Delete Index',
          okay : 'Delete',
          message : `Are you sure you want to delete index "${e.data}"?`,
          onOkay : () => {    
            const nv = [ ...v ]
            nv.splice( e.data, 1 )
            onSetValue( { attribute : attr, cxt, path, value : nv } )
            onClose()
          },
          onCancel : () => { onClose() }

        }
      } )
    }
  }, [ v, attr, cxt, path, onSetValue ] )

  const rtn = []
  for ( let i = 0; i < v.length; i++ ) {
    rtn.push( (
      <Flex direction="row">
        {/* <Button 
          variant="link"
          icon="fa fa-times fa-fw" 
          eventData={i}
          onClick={onDelete} /> */}
        <span className={S.attrLabel}>{i}</span> 
      </Flex>
    ) )
    rtn.push( (
      <SimAttributeView
        cxt={cxt}
        simulated={false}
        device={device}
        updaters={controller.state.updaters} 
        attribute={attr}
        name={null}
        eventData={i}
        value={v[i]} 
        onSetValue={onChange}/> 
    ) )
    rtn.push( (
      <div className={S.flexRight}>
        <div className={S.attrViewPath}>{path}/{i}</div> 
        <Button 
          variant="link"
          icon="fa fa-times fa-fw" 
          eventData={i}
          onClick={onDelete} />
      </div>  
    ) )
  }
  
  let name = attr.name
  if ( name[name.length - 1] === '*' ) {
    name = name.slice( 0, -1 )
  }

  return (
    <div className={S.grpAttrSpanView}>
      <div className={S.attrViewHeader}>
        <div className={S.attrViewLabel}>
          <span className={S.attrLabel}>{name}</span>
          <span className={S.attrArrow}>&rarr;</span><span className={S.attrArrow}>[</span>
        </div>
        <div className={S.flexRight}>
          <div className={S.attrViewPath}>{path}</div>
          <Button 
            variant="link"
            icon="fa fa-times fa-fw" 
            disabled={rtn.length === 0}
            eventData={CLEAR}
            onClick={onDelete} />
        </div> 
      </div>
      <div className={classNames( S.grpAttrView, S.grpAttrNested )} >
        {rtn}
        <Flex direction="row">
          <Button variant="link" disabled icon="fa fa-plus-circle fa-fw"/>
          <span className={S.attrLabel}>{v.length}</span> 
        </Flex>
        <SimAttributeView
          cxt={cxt}
          simulated={false}
          device={device}
          updaters={controller.state.updaters} 
          attribute={attr}
          name={null} 
          eventData={v.length}
          value={null} 
          onSetValue={onChange} />
      </div>
      
      <div className={S.attrViewLabel}><span className={S.attrArrow}>]</span></div>

    </div>
  )
}
